<template>
  <div>
    <v-text-field label="Enter the name for the new brand" :value="value.name" @input="emitValue('name', $event)" :rules="requiredRules" />
    <table>
      <tbody class="no-wrap">
        <tr class="mt-2">
          <td>
            <HvhUploadFileGroup text="Upload Target List" :value="value.targetListFile" accept=".csv" @input="emitValue('targetListFile', $event)" :rules="requiredRules" />
          </td>
          <td>
            <span class="sample-file" @click="downlaodListCsv">(Sample File)</span>
          </td>
        </tr>
        <tr class="mt-2">
          <td>
            <HvhUploadFileGroup text="Upload ZIP to Territory" :value="value.zipToTerritoryFile" accept=".csv" @input="emitValue('zipToTerritoryFile', $event)" :rules="requiredRules" />
          </td>
          <td>
            <span class="sample-file" @click="downloadTerritoryCSV">(Sample File)</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import HvhUploadFileGroup from '../common/uploadFile/HvhUploadFileGroup.vue';
import { saveAs } from 'file-saver';
export default {
  components: { HvhUploadFileGroup },
  props: ['value'],
  data() {
    var requiredRules = [v => !!v || v === false || 'Field is required'];

    return {
      requiredRules,
      numberRules: [
        ...requiredRules,
        v => (v > 0 && parseInt(v) == v) || 'You need to enter positive integer number',
      ],
    };
  },
  methods: {
    emitValue(prop, value) {
      this.$emit('input', {
        ...this.value,
        [prop]: value,
      });
    },
    downlaodListCsv() {
      var headers = 'ORGANIZATION_NAME,PHYSICIAN_GROUP_ID,PHYSICIAN_GROUP_TYPE,PHYSICIAN_GROUP_MAIN_SPECIALTY,LOCATION_ID,LOCATION_NAME,PHYSICIAN_GROUP_CITY,PHYSICIAN_GROUP_STATE,PHYSICIAN_GROUP_ZIP,OAS_TERRITORY_ID,OAS_TERRITORY_NAME,ROD_REGION_ID,ROD_REGION_NAME,HOSPITAL_ID,NPI,PHYSICIAN_FIRST_NAME,PHYSICIAN_LAST_NAME,CALL_FREQUENCY';
      // var headers = 'PHYSICIAN_GROUP_ZIP,CALL_FREQUENCY';
      var blob = new Blob([headers], { type: "text/plain;charset=utf-8" });
      saveAs(blob, `target-list-sample-file.csv`);
    },
    downloadTerritoryCSV() {
      var headers = 'ZIP,CITY,STATE,OAS_TERRITORY_ID,OAS_TERRITORY_NAME,ROD_REGION_ID,ROD_REGION_NAME';
      var blob = new Blob([headers], { type: "text/plain;charset=utf-8" });
      saveAs(blob, `territory-sample-file.csv`);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningAddBrand'] = this;
  },
}
</script>

<style lang="scss" scoped>
.sample-file {
  color: rgb(0, 47, 108);
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
}
</style>